<script>
  import { flip } from '../../../components/Utils.svelte'
  export let item
  export let base
</script>

<div class="row no-gutters">

  <div class="col-md-6 pad {flip(1, item.flip)}">
    <div class="row h-100 no-gutters">
      <div class="col-sm-12 my-auto lesspad">
        <h1>
          {#if item.title}{item.title}{:else}Lightyears Away.{/if}
        </h1>
        <div>
          <p>
            {@html item.body}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 {flip(2, item.flip)}">

    {#if item.images[0]}
      <img src={item.images[0].url} class="img-fluid" alt="right" />
    {:else if item.image}
      <img src={item.image} class="img-fluid" alt="right" />
    {:else}
      <img
        src="{base}themes/PlayFair/img/solar.jpg"
        class="img-fluid"
        alt="right" />
    {/if}
  </div>

</div>
